export const EVENTS = {
    INPUT: 'input',
};

export const INPUT_TYPES = {
    TEXT: 'text',
    PASSWORD: 'password',
};

export const ATTRIBUTES = {
    HELPER_TEXT: 'helper-text',
    ERROR_TEXT: 'error-text',
    ERROR: 'error',
    HAS_SLOT_ICON: 'has-slot-icon',
    HAS_SLOT_BTN: 'has-slot-btn',
    DISABLE_SUBMIT: 'disable-submit',
};

export const SELECTORS = {
    INPUT: 'input',
    SLOT: 'slot',
};

export const DEFAULT_INPUT_PROPERTIES = {
    name: { type: String },
    label: { type: String },
    placeholder: { type: String },
    value: { type: String, reflect: true },
    required: { type: Boolean },
    disabled: { type: Boolean },
    helperText: { type: String, attribute: ATTRIBUTES.HELPER_TEXT },
    error: { type: Boolean },
    errorText: { type: String, attribute: ATTRIBUTES.ERROR_TEXT },
    readonly: { type: Boolean, reflect: true },
};

export const CSS_VARIABLES = {
    AUTOFILL_BG: '--input-autofill-bg',
};
